import React, { Component, useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { actionCreators } from '../actions/globalAction';
import * as requestTypes from '../store/requestTypes';
import { Pagination } from '../components/Pagination';
import { Card, Row, Col } from 'react-bootstrap';
import { Loader } from '../components/solar/Loader';

import { getOptions } from '../components/options/solarstep1';
import { data } from '../components/data/solarstep1';
import { solarStep1 } from '../components/objects/solarstep1';

import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { SpezifischerGesamtertrag } from '../components/solar/SpezifischerGesamtertrag'
import { HighestGesamtertrag } from '../components/solar/HighestGesamtertrag'
import { HighestPower } from '../components/solar/HighestPower'
import { HighestBezugPower } from '../components/solar/HighestBezugPower'
import { Spezifischer } from '../components/solar/Spezifischer'
import { Tagesertrag } from '../components/solar/Tagesertrag'

import { Bar } from 'react-chartjs-2';

/**
 * Watches for navigation back to the home/step1 route.
 * Clears Redux state (skeletons appear) and re-triggers all API requests.
 */
function LocationWatcher({ dispatch, request }) {
    const location = useLocation();
    const hasFiredRef = useRef(false);

    useEffect(() => {
        if (!hasFiredRef.current) {
            hasFiredRef.current = true;
            return;
        }

        const onHome = location.pathname === '/' || /^\/step1/.test(location.pathname);
        if (onHome) {
            // Dispatch the correct action type that clears solarstep1 reducer data
            dispatch({ type: requestTypes.requestStartType.type });

            for (const k in solarStep1) {
                solarStep1[k].forceRefresh = true;
                request({ ...solarStep1[k] });
            }
        }
    }, [location, dispatch, request]);

    return null;
}
const WLW = connect(
    () => ({}),
    d => { const bound = bindActionCreators(actionCreators, d); return { dispatch: d, request: bound.request }; }
)(LocationWatcher);

/** Check if a prop value holds real data (not undefined, empty array, or 0) */
function hasValue(v) {
    if (v === null || v === undefined) return false;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === 'object') return Object.keys(v).length > 0;
    if (typeof v === 'number') return true; // 0 is a valid value
    if (typeof v === 'string') return v.length > 0;
    return false;
}

class Step1DataClass extends Component {
    componentDidMount() {
        const Year = parseInt(this.props.match.params.Year) || new Date().getFullYear();
        const Month = parseInt(this.props.match.params.Month) || new Date().getMonth()+1;

        solarStep1.BarDiagrammTageswerteClass.forceRefresh = true;
        solarStep1.BarDiagrammTageswerteClass.url = solarStep1.BarDiagrammTageswerteClass.defaultSegment + "/bar/" + Year + "/" + Month;

        for (var k in solarStep1) {
            this.props.request(solarStep1[k]);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        let result = !this.props.isLoaded || true;

        let nextYear = parseInt(nextProps.match.params.Year) || 0;
        let nextMonth = parseInt(nextProps.match.params.Month) || 0;

        let Year = parseInt(this.props.match.params.Year) || 0;
        let Month = parseInt(this.props.match.params.Month) || 0;

        if (nextYear != Year || nextMonth != Month) {
            result = true;

            solarStep1.BarDiagrammTageswerteClass.forceRefresh = true;
            solarStep1.BarDiagrammTageswerteClass.url = solarStep1.BarDiagrammTageswerteClass.defaultSegment + "/bar/" + nextYear + "/" + nextMonth;

            this.props.request(solarStep1["BarDiagrammTageswerteClass"]);
        }

        return result;
    }

    render() {
        // --- Per-section loading checks (not a global flag) ---
        const p = this.props;

        // Live section: AktuelleLeistung + AktuellerTagesertrag (+ optional: AktuellerSpezifischerTagesertrag)
        const liveReady = hasValue(p.AktuelleLeistungUI) && hasValue(p.AktuellerTagesertragUI);

        // Period section: Monatsertrag + Jahresertrag + Finanzierung + Jahres-Verbrauch
        const periodReady = hasValue(p.AktuellerMonatsGesamtertragUI)
            && hasValue(p.AktuellerGesamtertragJahrUI)
            && hasValue(p.JahresFinanzierungsfortschrittUI)
            && hasValue(p.JahresGesamtstromverbrauchUI);

        // Rekord section: highestpower + highestbezugpower + Gesamtertrag + spezifischerGesamtertrag + Tagesertrag + spezieserischer
        const rekordReady = hasValue(p.highestpowerUI)
            && hasValue(p.highestbezugpowerUI)
            && hasValue(p.GesamtertragUI)
            && hasValue(p.spezifischerGesamtertragUI)
            && hasValue(p.TagesertragUI)
            && hasValue(p.spezifischerertragUI);

        // Chart section: BarDiagramm data
        const uiData = p.BarDiagrammTageswerteUI || {};
        const chartReady = typeof uiData.Datum !== 'undefined';

        // Fallback: global loading (used for the fixed spinner)
        const loading = !p.isLoaded || !chartReady;

        // --- Extract UI data from Redux props ---
        let AktuellLeistung       = p.AktuelleLeistungUI || 0;
        let highestpowerUI        = p.highestpowerUI || {};
        let highestbezugpowerUI   = p.highestbezugpowerUI || {};
        let GesamtertragUI        = p.GesamtertragUI || {};
        let spezifischerertragUI  = p.spezifischerertragUI || {};
        let TagesertragUI         = p.TagesertragUI || {};
        let spezifischerGesamtertragUI = p.spezifischerGesamtertragUI || {};

        // Current values for KPI cards
        let AktuellTagesertrag    = p.AktuellerTagesertragUI || 0;
        let AktuellSpezifischTag  = p.AktuellerSpezifischerTagesertragUI || 0;
        let AktuellMonatsertrag   = p.AktuellerMonatsGesamtertragUI || 0;
        let AktuellJahresertrag   = p.AktuellerGesamtertragJahrUI || 0;
        let FinanzFortschritt     = p.JahresFinanzierungsfortschrittUI || {};
        let Stromverbrauch        = p.JahresGesamtstromverbrauchUI || 0;

        // --- Build chart data ---
        let chartData = {
            labels: [''],
            datasets: [{ data: [0] }]
        };
        if (typeof uiData.Datum !== 'undefined') {
            chartData = {
                labels: uiData.Datum,
                datasets: [
                    { ...data.datasets[0], data: uiData.Tagesertrag }
                ]
            };
        }

        // --- Render skeletons or real cards (per section) ---
        const renderLiveCards = () => {
            if (!liveReady) {
                return (
                    <div className="stat-cards-row">
                        <StatCardSkeleton variant="power" />
                        <StatCardSkeleton variant="energy" />
                    </div>
                );
            }
            return (
                <div className="stat-cards-row">
                    <StatCard
                        value={AktuellLeistung}
                        label="Aktuelle Leistung"
                        unit="W"
                        icon={<i className="bi bi-lightning-charge-fill" />}
                        variant="power"
                        description="Momentane Stromleistung der PV-Anlage in Watt. Live-Wert vom Wechselrichter."
                    />
                    <StatCard
                        value={AktuellTagesertrag}
                        label="Heute (Ertrag)"
                        unit="kWh"
                        icon={<i className="bi bi-sun-fill" />}
                        variant="energy"
                        subLabel={`Spezifisch: ${AktuellSpezifischTag}`}
                        description="Bisheriger Energieertrag heute in kWh. Spezifischer Ertrag = Ertrag geteilt durch Anlagenleistung."
                    />
                </div>
            );
        };

        const renderPeriodCards = () => {
            if (!periodReady) {
                return (
                    <div className="stat-cards-row">
                        <StatCardSkeleton variant="energy" />
                        <StatCardSkeleton variant="progress" />
                        <StatCardSkeleton variant="consumption" />
                        <StatCardSkeleton variant="specific" />
                    </div>
                );
            }
            return (
                <div className="stat-cards-row">
                    <StatCard
                        value={AktuellMonatsertrag}
                        label="Diesen Monat"
                        unit="kWh"
                        icon={<i className="bi bi-calendar2-week" />}
                        variant="energy"
                        description="Summe des erzeugten Stroms in diesem Kalendermonat."
                    />
                    <StatCard
                        value={AktuellJahresertrag}
                        label="Dieses Jahr"
                        unit="kWh"
                        icon={<i className="bi bi-calendar3" />}
                        variant="progress"
                        description="Bisheriger Gesamtstromertrag im laufenden Kalenderjahr."
                    />
                    <StatCard
                        value={FinanzFortschritt}
                        label="Finanzierung"
                        icon={<i className="bi bi-piggy-bank" />}
                        variant="consumption"
                        description="Abzahlungsfortschritt der PV-Anlagen-Finanzierung. Zeigt verbleibende oder bereits erlöste Beträge."
                    />
                    <StatCard
                        value={Stromverbrauch}
                        label="Jahres-Verbrauch"
                        unit="kWh"
                        icon={<i className="bi bi-plug-fill" />}
                        variant="specific"
                        description="Geschätzter oder gemessener Stromverbrauch des Haushalts im laufenden Jahr."
                    />
                </div>
            );
        };

        // --- Rekordwerte data as StatCards ---
        const renderRekordCard = () => {
            if (!rekordReady) {
                return (
                    <Card className="chart-card rekordkarte">
                        <Card.Header as="h5">
                            <i className="bi bi-trophy" /> Gesamtertrag &amp; Rekordwerte
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={6}>
                                    <p className="rekord-label"><strong>Gesamtertrag</strong></p>
                                    <div className="stat-cards-row">
                                        <StatCardSkeleton variant="energy" />
                                        <StatCardSkeleton variant="progress" />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <p className="rekord-label"><strong>Rekordwerte</strong></p>
                                    <div className="stat-cards-row">
                                        <StatCardSkeleton variant="power" />
                                        <StatCardSkeleton variant="specific" />
                                        <StatCardSkeleton variant="energy" />
                                        <StatCardSkeleton variant="consumption" />
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                );
            }

            return (
                <Card className="chart-card rekordkarte">
                    <Card.Header as="h5">
                        <i className="bi bi-trophy" /> Gesamtertrag &amp; Rekordwerte
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                <p className="rekord-label"><strong>Gesamtertrag</strong></p>
                                <div className="stat-cards-row">
                                    <StatCard
                                        value={spezifischerGesamtertragUI}
                                        label="Spezifisch"
                                        icon={<i className="bi bi-chart-pie" />}
                                        variant="energy"
                                        description="Kumulierter spez. Ertrag in kWh/kWp — Gesamtertrag dividiert durch installierte Leistung."
                                    />
                                    <StatCard
                                        value={GesamtertragUI}
                                        label="Gesamtsumme"
                                        icon={<i className="bi bi-hash" />}
                                        variant="progress"
                                        description="Lebenszeit-Gesamtertrag der Anlage seit Inbetriebnahme in kWh."
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <p className="rekord-label"><strong>Rekordwerte</strong></p>
                                <div className="stat-cards-row">
                                    <StatCard
                                        value={highestpowerUI.max || highestpowerUI}
                                        label="H&ouml;chst-Leistung"
                                        unit="W"
                                        icon={<i className="bi bi-lightning-fill" />}
                                        variant="power"
                                        description="Rekordwert: Höchste je gemessene elektrische Leistung der Anlage in Watt."
                                    />
                                    <StatCard
                                        value={spezifischerertragUI}
                                        label="H&ouml;chster Spezif."
                                        icon={<i className="bi bi-percent" />}
                                        variant="specific"
                                        description="Beste je erreichte spezifische Ertragsleistung. Maß für die Effizienz der Module bezogen auf kWp."
                                    />
                                    <StatCard
                                        value={TagesertragUI}
                                        label="H&ouml;chster Tagesertrag"
                                        unit="kWh"
                                        icon={<i className="bi bi-sun-fill" />}
                                        variant="energy"
                                        description="Rekordwert: Höchster Stromertrag an einem einzigen Tag in kWh."
                                    />
                                    <StatCard
                                        value={highestbezugpowerUI.max || highestbezugpowerUI}
                                        label="H&ouml;chst-Bezug"
                                        unit="W"
                                        icon={<i className="bi bi-plug-fill" />}
                                        variant="consumption"
                                        description="Rekordwert: Höchster gleichzeitiger Strombezug aus dem Netz in Watt."
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            );
        };

        return (
            <div>
                {/* Watch for navigation back to this route and re-fetch data */}
                <WLW />

                <Loader show={loading} />

                {/* ========== Section 1: Live KPI Cards ========== */}
                <Row className="mb-2">
                    <Col>
                        <h4 style={{ fontWeight: '600' }}>
                            <i className="bi bi-broadcast" /> Live
                        </h4>
                    </Col>
                </Row>
                {renderLiveCards()}

                {/* ========== Section 2: Period KPI Cards ========== */}
                <Row className="mb-2">
                    <Col>
                        <h4 style={{ fontWeight: '600' }}>
                            <i className="bi bi-calendar-event" /> Zeitraum
                        </h4>
                    </Col>
                </Row>
                {renderPeriodCards()}

                {/* ========== Section 3: Tagesertrag Chart with Pagination Arrows ========== */}
                <ChartCardWithPagination loading={loading} routeSegment={'step1'} onlyYear={false} match={this.props.match} history={this.props.history}>
                    <Card className="chart-card">
                        <Card.Body>
                            <Bar data={chartData} options={{ ...getOptions(), animation: false }} />
                        </Card.Body>
                    </Card>
                </ChartCardWithPagination>

                {/* ========== Section 4: Gesamtertrag & Rekordwerte ========== */}
                {renderRekordCard()}

                {/* ========== Pagination (keep for small screens / keyboard) ========== */}
                <Pagination routeSegment={'step1'} onlyYear={false} prop={this.props} options={getOptions()} />
            </div>
        );
    }
}

export default connect(
    state => state.solarstep1Reducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Step1DataClass);
